export default "/_next/static/images/Google_AI_Studio_2025-12-06T00_24_50.650Z 13-fae36228df55a8f4013012fa2147f20d.png";